import {
  default as React,
  FunctionComponent,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useSelector } from 'react-redux'
import useThunkDispatch from '../common/useThunkDispatch'
import useTitle from 'react-use/lib/useTitle'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import Button from '../components/Button'
import {
  requestPublishedMessage,
  publishMessage,
  updateMessage,
  archiveMessage,
} from './internalMessagesActions'
import { publishedMessageSelector } from './internalMessagesSelectors'

const InternalMessages: FunctionComponent = () => {
  useTitle('Messages - Forshaw')
  const dispatch = useThunkDispatch()
  const published = useSelector(publishedMessageSelector)
  const [content, setContent] = useState('')
  const isPublished = useMemo(() => !!published, [published])
  const formattedPublishedDate = useMemo(
    () =>
      published
        ? new Date(published.publishedAt)
            .toLocaleString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })
            .toUpperCase()
            .replace(',', '')
        : '',
    [published],
  )

  useEffect(() => {
    dispatch(requestPublishedMessage())
  }, [dispatch])

  const onPublish = async () => {
    await dispatch(publishMessage(content))
    alert('Message published successfully')
  }

  const onSave = async () => {
    if (!published) return
    await dispatch(updateMessage(published.id, content))
    alert('Message saved')
  }

  const onArchive = () => {
    if (!published) return
    dispatch(archiveMessage(published.id))
    setContent('')
  }

  useEffect(() => {
    if (published) setContent(published.content)
  }, [published])

  return (
    <div className="container wonder-scroll">
      <div className="filter -centered">
        <div className="input">
          <div className="input_title -flex-between">
            <span>MESSAGE</span>
            {published && (
              <span className="input_title-published">
                PUBLISHED at {formattedPublishedDate}
              </span>
            )}
          </div>
          <textarea
            className="input_textarea -sm"
            rows={6}
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
          <div className="input_hint">
            Markup: **bold text**, *italic text*, [link caption](url)
          </div>
          <div className="input_title" style={{ marginTop: '16px' }}>
            PREVIEW
          </div>
          <div className="input_preview user-modal_message-content">
            <ReactMarkdown
              remarkPlugins={[remarkBreaks]}
              components={{
                a: ({ node, ...props }) => (
                  <a {...props} target="_blank" rel="noopener noreferrer" />
                ),
              }}
            >
              {content}
            </ReactMarkdown>
          </div>
          <div className="filter_col -small -actions">
            {!isPublished ? (
              <Button
                color="success"
                onClick={onPublish}
                disabled={!content.trim()}
                className="-w152"
              >
                Publish
              </Button>
            ) : (
              <>
                <Button color="danger" onClick={onArchive} className="-w152">
                  Archive
                </Button>
                <Button
                  color="success"
                  onClick={onSave}
                  disabled={!content.trim()}
                  className="-w152"
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InternalMessages
